<template>
    <div class="h-full pt-0.5 w-full">
        <div class="flex justify-between items-center lg:px-6 bg-white dark:bg-black h-10 relative">
            <h5 class="font-bold text-28">Timeline</h5>

            <div class="flex justify-end select-none">
                <PageOptions
                    :defaults="parentPage.defaults"
                    :page="page"
                    :parentPage="parentPage"
                    :user="parentPage.user"
                    class="mr-6"
                    resetLabel="Reset page"
                    :tableLabelChangeCheck="tableLabelChangeCheck"
                />

                <DropdownV2 ref="menu" emitName="timeline-create-menu" forceSide="right">
                    <template #button="{ open }">
                        <div class="bg-black h-10 w-10 flex items-center justify-center">
                            <IconPlus class="h-5 w-5 transition-transform stroke-white" />
                        </div>
                    </template>
                    <template #menu>
                        <div class="table-multi-select-menu bg-black min-w-[198px]">
                            <slot name='addMenu' />

                            <button v-if="type == 102" data-close @click="create('Deal')">
                                <IconDealWhite class="h-4.5 w-4.5" />
                                <p class="pl-2">Deal</p>
                            </button>
                            <button data-close @click="create('Task')">
                                <IconTasks class="h-4.5 w-4.5 stroke-white" />
                                <p class="pl-2">Task</p>
                            </button>
                            <button data-close @click="create('Appointment')">
                                <IconTime class="h-4.5 w-4.5 stroke-white" />
                                <p class="pl-2">Event</p>
                            </button>
                            <button data-close @click="create('Note')">
                                <IconNote class="h-4.5 w-4.5 stroke-white" />
                                <p class="pl-2">Note</p>
                            </button>
                            <button data-close @click="create('Email')" class="stroke-white disabled:stroke-grey-800">
                                <IconEmail class="h-4.5 w-4.5" />
                                <p class="pl-2">Email</p>
                            </button>
                            <ButtonCRM data-close @click="create('SMS')" class="stroke-white disabled:stroke-grey-800">
                                <IconSms class="h-4.5 w-4.5" />
                                <p class="pl-2">SMS</p>
                            </ButtonCRM>
                            <ButtonCRM data-close @click="create('WhatsApp')" class="stroke-white disabled:stroke-grey-800">
                                <IconSms class="h-4.5 w-4.5" />
                                <p class="pl-2">WhatsApp</p>
                            </ButtonCRM>
                            <ButtonCRM class="stroke-white disabled:stroke-grey-800" data-close can="plus"
                                v-if="type == 102 || type == 103" 
                                @click="
                                    () => {
                                        $event.$emit('modal-open', {
                                            view: 'Upload',
                                            options: {
                                                modelId: id,
                                                modelType: type,
                                                folders: [],
                                            },
                                        })
                                    }
                                "
                            >
                                <IconAttachFile class="h-4.5 w-4.5" />
                                <p class="pl-2">File</p>
                            </ButtonCRM>
                            <button
                                v-if="type == 102 || type == 103" 
                                data-close
                                @click="
                                    () => {
                                        $event.$emit('modal-open', {
                                            view: 'PipelineStageEdit',
                                            editingModel: { key: 'folder', modelId: id, modelType: type },
                                        })
                                    }
                                "
                            >
                                <IconFolder class="h-4.5 w-4.5 stroke-white" />
                                <p class="pl-2">Folder</p>
                            </button>
                        </div>
                    </template>
                </DropdownV2>
            </div>
        </div>

        <div class="border-b border-grey-500 bg-white dark:bg-black select-none relative">
            <TimelineFilters
                v-if="page != null && page.user != null"
                :page="page"
                :type='type'
                :pageDefaults="page.defaults"
                :pageUser="page.user"
                @pageUpdate="
                    (_filters) => {
                        this.page.user.filters = _filters
                        this.updated()
                    }
                "
            />

            <div v-else>
                <button class="flex items-center justify-between px-0 lg:px-6 w-full pt-4 pb-0 lg:pb-4">
                    <div class="flex items-start">
                        <IconFilters class="w-4.5 h-4.5 lg:w-5 lg:h-5 stroke-black dark:stroke-white shrink-0" />

                        <p class="text-15 text-grey-900 pl-2 pr-6 text-left hidden lg:block">
                            Displaying
                            <b class="text-black dark:text-white font-semibold">All activity</b>
                            by
                            <b class="text-black dark:text-white font-semibold">Everyone</b>
                            from
                            <b class="text-black dark:text-white font-semibold">All time</b>
                        </p>

                        <p class="text-15 text-grey-900 pl-2 block lg:hidden">Filters</p>
                    </div>

                    <div class="w-10 h-12 flex items-center justify-center shrink-0">
                        <IconArrowDown :class="{ 'rotate-180': open }" class="h-4.5 w-4.5 icon-hover transition-all duration-300 shrink-0" />
                    </div>
                </button>
            </div>
        </div>

        <!-- min-h-[calc(100%-120px)] -->

        <div class='max-h-[600px] h-full flex items-center justify-between' v-if='page.loading'>
            <ClientOnly>
                <Vue3Lottie :animationData="ZapoLogoJson" :height="100" :width="100" :loop="true" @onLoopComplete="onLoopComplete" />
            </ClientOnly>
        </div>

        <div class="flex flex-col justify-between" v-else>
            <div v-if="page?.data?.data != null" class="flex flex-col">
                <!-- tr-slide-right -->
                <!-- <transition-group appear name='' tag='div'> -->
                <template v-for="(entry, ei) in page.data.data" :key="entry.id">
                    <div
                        :class="{
                            'timeline-log': entry.historial_type == null || entry.historial_type == 204 || entry.log != null,
                        }"
                        :style="{ transitionDelay: ei * 50 + 'ms' }"
                    >
                        <!-- <div v-if="showDate(entry, ei)" class="flex justify-center pt-4">
                            <p class="text-center text-12 font-medium text-grey-800 px-2 w-auto block bg-grey-300 dark:bg-coal rounded-full">
                                <span v-if="parentPage.user.labels.timeline.date">{{ $moment(entry.created_at).format('Do MMMM YYYY') }}</span>
                                <span v-if="parentPage.user.labels.timeline.date && parentPage.user.labels.timeline.recency"> (</span>
                                <span v-if="parentPage.user.labels.timeline.recency">{{ $moment().to(entry.created_at, false) }}</span>
                                <span v-if="parentPage.user.labels.timeline.date && parentPage.user.labels.timeline.recency">)</span>
                            </p>
                        </div> -->

                        <Entry :entry="entry" :origin="model" :page="parentPage" :modelCreated />

                    </div>
                </template>
                <!-- </transition-group> -->
            </div>

            <!--  <Empty v-if='pageData != null && pageData.data != null && pageData.data.length == 0'
				 :title='view == "all" ? "You have nothing on your timeline" : "You have no "+view'
				 /> -->

            <!-- class='px-4 lg:px-14 pb-22'  -->
            <!-- <div class="lg:flex items-center justify-center mt-8 lg:mt-10 px-4 lg:pl-6 pb-22"> -->
            <div class="block lg:flex justify-between items-center lg:flex-row flex-col pt-10 lg:pb-10 relative lg:mx-4 -mx-4 min-h-[158px] lg:min-h-0">
                <div class='flex items-center justify-center'>
                    <Pagination v-if="page != null" :page="page" :pagination="page.data" />
                </div>

                <DropdownV2
                    class='block lg:hidden w-full'
                    :menuPush='true'
                    :scrollToBottomFirst='true'
                    v-if="page.defaults != null && page.defaults.rows != null"
                >
                    <template #button="{ open }">
                        <div class="flex items-center justify-center bg-white dark:bg-black dark:bg-black w-full py-4">
                            <p class="pr-2 text-14">
                                Showing {{ showing }} of {{ page.data.total }}
                                {{ page.data.total != 1 ? 'entries' : 'entry' }}
                            </p>
                            <IconArrowDown :class="{ 'rotate-180': open }" class="h-4.5 w-4.5 stroke-black transition-all" />
                        </div>
                    </template>

                    <template #menu>
                        <div class="table-multi-select-menu bg-black min-w-[260px]">
                            <button
                                v-for="i in page.defaults.rows"
                                :class="{
                                    'text-grey-800': i == page.user.rows,
                                }"
                                :disabled="i == page.user.rows"
                                data-close
                                @click="
                                    () => {
                                        page.user.rows = i
                                        page.call().updated()
                                    }
                                "
                            >
                                Show {{ i }} entries
                            </button>
                        </div>
                    </template>
                </DropdownV2>

                <DropdownV2
                    v-if="page.defaults != null && page.defaults.rows != null"
                    :menuSpace="8"
                    class="lg:block hidden lg:mt-0 mt-3"
                    forceDirection="bottom"
                    forceSide="right"
                    menuClass="!overflow-hidden"
                >
                    <template #button="{ open }">
                        <div class="flex items-center bg-white dark:bg-black dark:bg-black">
                            <p class="pr-2 text-14">
                                Showing {{ showing }} of {{ page.data.total }}
                                {{ page.data.total != 1 ? 'entries' : 'entry' }}
                            </p>
                            <IconArrowDown :class="{ 'rotate-180': open }" class="h-4.5 w-4.5 stroke-black transition-all" />
                        </div>
                    </template>

                    <template #menu>
                        <div class="table-multi-select-menu bg-black min-w-[260px]">
                            <button
                                v-for="i in page.defaults.rows"
                                :class="{
                                    'text-grey-800': i == page.user.rows,
                                }"
                                :disabled="i == page.user.rows"
                                data-close
                                @click="
                                    () => {
                                        page.user.rows = i
                                        page.call().updated()
                                    }
                                "
                            >
                                Show {{ i }} entries
                            </button>
                        </div>
                    </template>
                </DropdownV2>
            </div>
        </div>

        <!-- <CreateEntry ref='entryCreateModal'
			:create='creating'
			:visable='showCreatingBox'
			:modelId='id'
			:model='type'
			:communications='communications'
			:editing='editing'
			@submitted='submitted'
			:page='page'
		/> -->
    </div>
</template>

<script>
import TimelineFilters from './timeline-filters'
import Page from '~/mixins/page-new.js'
import PageOptions from '~/components/customer/table/table-options'
import ZapoLogoJson from '~/assets/animation-zapo-loading.json'
import Entry from './elements/entry'
import CreateEntry from './create-entry'
import Pagination from '~/components/customer/table/table-pagination'

export default {
    mixins: [Page],

    props: {
        id: [Number, String],
        type: String,
        modelCreated: String,
        model: Object,
        communications: Array,
        parentPage: Object,
        dealOrigin: { type: Object, default: null },
        tableLabelChangeCheck: {
            type: Function,
            default: function (labels, label, enabled) {
                // console.log(labels)
                // console.log([['title', 'description'].indexOf(label), labels.title, labels.description])
                if (['title', 'description'].indexOf(label) != -1 && labels.title == false && labels.description == false) {
                    labels[label == 'title' ? 'description' : 'title'] = true
                }
            },
        },
    },

    beforeMount() {
        // console.log("Before mount");

        this.options({
            url: '/history',
            params: {
                belongs_id: this.id,
                belongs_type: this.type,
            },
        })
    },

    data() {
        return {
            views: ['all', 'task', 'note', 'sms', 'draft'],
            view: 'all',
            showCreateMenu: false,
            createable: ['task', 'note', 'sms', 'appointment', 'deal'],
            showCreatingBox: false,
            creating: null,
            editing: null,
            lastTimelineDateText: null,
            showResetTable: false,
            ZapoLogoJson
        }
    },

    mounted() {
        this.$event.$on('timeline-published', this.updated)
        this.$event.$on('timeline-completed', this.updated)
        this.$event.$on('timeline-pinned', this.updated)
        this.$event.$on('timeline-deleted', this.updated)

        this.$event.$on('timeline-create', (a) => {
            this.create(a[0], a[1])
        })

        this.$event.$on('timeline-refresh', this.updated)

        this.$event.$on('timeline-edit', (data) => {
            this.creating = data.type
            this.editing = data.data

            this.$refs.entryCreateModal.open()
        })

        document.body.addEventListener('keydown', this.keyOpen)
    },

    unmounted() {
        document.body.removeEventListener('keydown', this.keyOpen)
    },

    methods: {
        submitted() {
            this.parentPage.call().updated()
        },

        keyOpen(event) {
            switch (true) {
                case this.$ctrlKey(event, 's'):
                    this.create('SMS')
                    break
                case this.$ctrlKey(event, 't'):
                    this.create('Task')
                    break
                case this.$ctrlKey(event, 'a'):
                    this.create('Appointment')
                    break
                case this.$ctrlKey(event, 'd'):
                    this.create('Deal')
                    break
                case this.$ctrlKey(event, 'n'):
                    this.create('Note')
                    break
                case this.$ctrlKey(event, 'e'):
                    this.create('Email')
                    break
                case this.$ctrlKey(event, 'f'):
                    this.$event.$emit('modal-open', {
                        view: 'Upload',
                        options: {
                            modelId: this.id,
                            modelType: this.type,
                            folders: [],
                        },
                    })
                    break
            }
        },

        // updated() {
        //     console.trace('call updated')
        //     // this.page.call().updated()
        // },

        viewIcon(view) {
            switch (view) {
                case 'emails':
                    return 'email'
                    break
                case 'notes':
                    return 'note'
                    break
                case 'all':
                    return null
                    break
                default:
                    return view
            }
        },

        create(type, extraOptions = {}) {
            if (this.createable.indexOf(this.type) === false) {
                return
            }

            let options = {
                dealOrigin: this.dealOrigin,
                model: this.model,
                ...extraOptions
            }

            if (type == 'Task') {
                options.task = 0
            }
            if (type == 'Appointment') {
                options.task = 1
                type = 'Task'
            }

            this.$event.$emit('modal-open', {
                view: type,
                modelId: this.id,
                modelType: this.type,
                options: options,
            })

            // this.editing = null;
            // this.creating = type;
            // this.showCreatingBox = true;
            // this.$refs.entryCreateModal.open()
            // this.showCreateMenu = false;
        },

        setView(view) {
            this.view = view
            this.get()
        },

        showDate(entry, ei) {
            let isFirst = ei == 0
            let isLast = this.page.data.data.length - 1 == ei
            let lastWasPinned = !isFirst && this.page.data.data[ei - 1].pinned !== null

            let pinned = entry.pinned !== null
            let sameAsLastDate =
                !isFirst &&
                this.$moment(entry.created_at).format('DD/MM/YYYY') ==
                    this.$moment(this.page.data.data[ei - 1].created_at).format('DD/MM/YYYY')

            // !(isLast || sameAsLastDate || (lastWasPinned && pinned))

            // console.log({
            //     isFirst:isFirst,
            //     isLast:isLast,
            // })

            // (
            //     ((lastWasPinned && !pinned)
            //     || !sameAsLastDate)
            //     && !isLast
            // )

            return isFirst ? !pinned : !(sameAsLastDate || (lastWasPinned && pinned))
        },

        resetTable() {
            this.$event.$emit('page-reset')
            this.showResetTable = false
        },

        setFilterDateRange() {
            this.setFilter('date_range', [this.$refs.dateRange.lStartsAt, this.$refs.dateRange.lEndsAt])
        },
    },

    computed: {
        createNumbers() {
            switch (
                true
                // case this.contact != null:
                //     return [{
                //         number: this.contact.phone_number,
                //         fullName: this.contact.fullName()
                //     }]
                // break;
            ) {
            }

            return null
        },

        showing() {
            return this.page.data.per_page > this.page.data.total ? this.page.data.total : this.page.data.per_page
        },

        createEmails() {
            switch (true) {
                case this.contact != null && this.contact.email != null:
                    return [
                        {
                            number: this.contact.email,
                            fullName: this.contact.fullName(),
                        },
                    ]
                    break
            }

            return null
        },

        tasks() {
            if (this.pageData.data == null) {
                return []
            }

            return this.pageData.data.filter((h) => {
                return h.historial_type == 'App\\Models\\Task'
            })
        },
    },

    watch: {
        view() {
            return this.get()
        },
    },

    components: {
        TimelineFilters: TimelineFilters,
        PageOptions: PageOptions,
        Entry: Entry,
        // 'Calendar': Calendar,
        // Note: Note,
        // Task: Task,
        // SMS: SMS,
        // Email: Email,
        // Deal: Deal,
        // Appointment: Appointment,
        // LeadCall: LeadCall,
        // LeadForm: LeadForm,
        // Log: Log,
        CreateEntry: CreateEntry,
        Pagination: Pagination,
        // 'Empty': Empty,
        // 'DateRange': DateRange,
    },
}
</script>
